import {apiFetch} from '../../Util';

async function createUserOrder(orderType, diamondIdList, markupPercent = 0.0, messageBody = null) {
  const createParams = {
    markup_percent: markupPercent,
    order_type: orderType,
    message_body: messageBody,
  };
  const response = await apiFetch.create(
    ['user_order'],
    createParams
  );
  const newUserOrder = response.created;

  const addParams = {
    diamond_id_list: diamondIdList,
  };
  await apiFetch.create(
    ['user_order', newUserOrder.id, 'order_diamond'],
    addParams
  );

  return newUserOrder;
}

export { createUserOrder };
